import {trackPromise} from "react-promise-tracker";
import {getUrl} from "../../constants/urls";
import Call from "../../service/axios";

export const requestInventoryReportsAsync = (pageUrl) => {
  const url = pageUrl ? pageUrl : getUrl("inventoryReports");
  return trackPromise(Call.get(url));
};
